export default "__VITE_ASSET__c01dce26__"